import { getAppSource } from './AppSource';

import Env from './Env';

const formatQuestId = (id) => (id === 0 ? 'challenge' : id);
const formatGameInfo = (game) => {
  if (game?.gameId && game?.level) {
    return `${game.gameId}-${game.level}`;
  }

  return game;
};

const hasRumMethod = (method) => typeof DD_RUM?.[method] === 'function';

export const RUM_GLOBAL_CONTEXT_KEYS = {
  KEYCLOAK_SESSION_ID: 'keycloak_session_id',
  AMP_ID: 'amp_id',
  AQUA_ID: 'aqua_id',
  QUEST_ID: 'quest_id',
  GAME: 'game_level',
  APP_SOURCE: 'app_source',
  MEASURE: 'measure',
  PRODUCT: 'product',
};

export const RUM_DEV_KEY = 'aqua_dev';

export const setInitialRumGlobalContext = (sessionId, ampId) => {
  const {
    KEYCLOAK_SESSION_ID, AMP_ID, AQUA_ID, QUEST_ID, GAME, APP_SOURCE, MEASURE, PRODUCT,
  } = RUM_GLOBAL_CONTEXT_KEYS;
  const appSource = getAppSource();

  const rumGlobalContext = {
    [AMP_ID]: ampId,
    [KEYCLOAK_SESSION_ID]: sessionId,
    [AQUA_ID]: null,
    [QUEST_ID]: null,
    [GAME]: null,
    [APP_SOURCE]: appSource,
    [MEASURE]: null,
    [PRODUCT]: null,
  };

  const rumDevKeyFromStorage = sessionStorage.getItem(RUM_DEV_KEY);
  if (!Env.isProd && rumDevKeyFromStorage) {
    rumGlobalContext[RUM_DEV_KEY] = rumDevKeyFromStorage;
  }

  DD_RUM.onReady(() => {
    DD_RUM.setGlobalContext(rumGlobalContext);
    setView('metagame');
  });
};

export const setRumDevKey = (val) => {
  if (Env.isProd || !hasRumMethod('setGlobalContextProperty')) return;

  DD_RUM.setGlobalContextProperty(RUM_DEV_KEY, val);
  sessionStorage.setItem(RUM_DEV_KEY, val);
};

export const setView = (view) => {
  if (hasRumMethod('startView')) {
    DD_RUM.startView(view);
  }
};

export const getRumDevKey = () => sessionStorage.getItem(RUM_DEV_KEY) || '';

export const removeRumDevKey = () => {
  if (Env.isProd || !hasRumMethod('removeGlobalContextProperty')) return;

  DD_RUM.removeGlobalContextProperty(RUM_DEV_KEY);
  sessionStorage.removeItem(RUM_DEV_KEY);
};

export const setRumAquaId = (id) => {
  if (hasRumMethod('setGlobalContextProperty')) {
    DD_RUM.setGlobalContextProperty(RUM_GLOBAL_CONTEXT_KEYS.AQUA_ID, id);
  }
};

export const setRumQuestId = (id) => {
  if (hasRumMethod('setGlobalContextProperty')) {
    const formattedQuestId = formatQuestId(id);

    DD_RUM.setGlobalContextProperty(RUM_GLOBAL_CONTEXT_KEYS.QUEST_ID, formattedQuestId);
  }
};

export const setRumGame = (gameInfo) => {
  if (hasRumMethod('setGlobalContextProperty')) {
    const formattedGame = formatGameInfo(gameInfo);

    DD_RUM.setGlobalContextProperty(RUM_GLOBAL_CONTEXT_KEYS.GAME, formattedGame);
  }
};

export const setRumMeasure = (id = null) => {
  if (hasRumMethod('setGlobalContextProperty')) {
    DD_RUM.setGlobalContextProperty(RUM_GLOBAL_CONTEXT_KEYS.MEASURE, id);
  }
};

export const setRumProduct = (product = null) => {
  if (hasRumMethod('setGlobalContextProperty')) {
    DD_RUM.setGlobalContextProperty(RUM_GLOBAL_CONTEXT_KEYS.PRODUCT, product);
  }
};

export const logRumError = (errorMessage = '', errorContext) => {
  if (!errorMessage) {
    return;
  }
  console.warn(errorMessage, errorContext);

  if (hasRumMethod('addError')) {
    DD_RUM.addError(new Error(errorMessage), { errorContext });
  }
};

export const logRumAction = (actionName = '', actionContext) => {
  if (actionName && hasRumMethod('addAction')) {
    DD_RUM.addAction(actionName, { actionContext });
  }
};
